export const APP_PAGE = {
  PROFILE_DROPDOWN: "profile-dropdown",
  DASHBOARD: "dashboard",
  VIDEOS: "videos",
  STREAM: "stream",
  CLIPS: "clips",
  EDIT_CLIPS: "edit-clips",
  ADD_VIDEO: "add-new-stream",
  EDIT_VIDEO: "edit-video",
  LIVE_VIDEO: "live-video",
  LIVE_EDIT: "live-edit",
  CLIP_EDITOR: "clipInfo",
  HIGHLIGHT_EDITOR: "editor-page",
  HIGHLIGHTS: "highlights",
  RULE_LISTING: "rule-listing",
  RULE_EDITOR: "rule-editor",
  RULE_BASED_STREAMS: "rule-overview",
  STUDIO: "studio",
  ARCHIVAL: "archival",
  CONFIGURATION: "configuration",
  KEY_MANAGEMENT: "key-management",
  ORGANIZATION_PROFILE: "organization-profile",
  QUICK_HIGHLIGHT: "quick-highlight",
  WEB_STORY: "web-story",
  MATCH_SCHEDULE: "match-schedule",
  MATCH_SCHEDULE_UPLOAD_CSV: "match-schedule-upload-csv",
  INTERNAL_SCHEDULE: "internal-schedule",
  INTERNAL_SCHEDULE_UPLOAD_CSV: "internal-schedule-upload-csv",
  THIRD_PARTY_INTEGRATION_CALLBACK: "third-party-integration-callback",
  PUBLISH_HISTORY: "publish-history",
  VIDEO_PLAYER: "video-player",
  RULE_OUTPUTS: "rule-outputs",
  STUDIO_PUBLISH: "studio-publish",
  GRAPHICS: "graphics",
  GRAPHICS_TEMPLATE: "graphics-template",
  THUMBNAIL_TEMPLATE: "thumbnail-template",
  TOURNAMENT_CONFIG: "tournament-config",
};

export const APP_VERSION = {
  V2: "v2",
};

export const clipPageTabOptions = Object.freeze({
  clip: "clip",
  highlight: "highlight",
  webStory: "stories",
  published: "published",
  matchVideo: "matchVideo",
  exported: "exported",
  promo: "promo",
  rules: "rules",
});

export const rulesTabOptions = Object.freeze({
  rules: "rules",
  outputs: "outputs",
});

export const clipPublishModalTabOptions = Object.freeze({
  publish: "publish",
  transcript: "transcript",
  transform: "transform",
  publishHistory: "publish-history",
  info: "info",
  templates: "templates",
  thumbnails: "thumbnails",
  trim: "trim",
  subtitles: "subtitles",
  autoFlip: "autoFlip",
  dynamicFlip: "dynamicFlip",
});

export const clipPublishModalInfoSectionTabOptions = Object.freeze({
  basicDetails: "basic-details",
  json: "json",
});

export const clipPageHighlightSubOptions = Object.freeze({
  promo: "promo",
  clip: "clip-highlight",
  clipListDraft: "drafts-highlight",
  clipListGenerated: "generated-highlight",
  all: "all-highlight",
});

export const HighlightPageSubHeaderTabOptions = {
  DRAFTS: "Drafts",
  GENERATED: "Generated",
  SAVES_AS_CLIP: "Saved as a clip",
  FROM_THE_RULES: "From the rules",
};

export const clipPagePublishedSubOptions = Object.freeze({
  clips: "clips",
  highlights: "highlights",
  all: "all-published",
});

export const cropperModalTabOptions = Object.freeze({
  autoFlip: "Auto Flip",
  dynamicFlip: "Dynamic Flip",
});

export const templateSkeletonStatusOptions = Object.freeze({
  inProgress: "in_progress",
  failed: "failed",
  exportStarted: "export_started",
  exportComplete: "export_complete",
  exportFailed: "export_failed",
});

export const liveEditTabOptions = Object.freeze({
  clipsInQueue: "clips-in-queue",
  finalClips: "final-clips",
  screenshots: "screenshots",
});
const playerField = { label: "Player", name: "player", required: false, placeholder: "Enter player name" };

const sharedTeamFields = [
  { label: "Team1", name: "team1", required: true, placeholder: "Enter team1 name" },
  { label: "Team2", name: "team2", required: true, placeholder: "Enter team2 name" },
  { label: "Time", name: "time", required: true, placeholder: "Enter match time" },
  { label: "Quarter", name: "quarter", required: true, placeholder: "Enter quarter" },
];

export const CATEGORY_FIELDS = {
  default: [
    { label: "Title", name: "title", required: true, placeholder: "Enter title" },
    { label: "Score", name: "score", required: true, placeholder: "Enter score", excludeCategories: ["Olympics"] },
    { label: "Webstory Redirect Link", name: "matchLink", required: false, placeholder: "Enter redirect link" },
  ],
  cricket: [
    { label: "Overs", name: "overs", required: true, placeholder: "Enter overs" },
    { label: "Team", name: "team1", required: true, placeholder: "Enter team name" },
    playerField,
  ],
  teamSports: sharedTeamFields,
  football: [playerField, ...sharedTeamFields],
  Olympics: [playerField, { label: "Event", name: "event", required: true, placeholder: "Enter event" }],
};

export const BUMPER_FIELDS = [
  { label: "Title", name: "title", required: true, placeholder: "Enter title" },
  { label: "Webstory Redirect Link", name: "matchLink", required: false, placeholder: "Enter redirect link" },
];

// Categories that use teamSports fields
export const TEAM_SPORT_CATEGORIES = ["basketball", "American Football", "ice_hockey", "Baseball"];

export const webStoryFormFields = [
  { name: "title", label: "Title", type: "text", required: true, placeholder: "Enter Title" },
  { name: "templateTitle", label: "Template Title", type: "text", required: true, placeholder: "Enter Template Title" },
  {
    name: "matchLink",
    label: "Webstory Redirect Link",
    type: "text",
    required: true,
    placeholder: "Enter Redirect Link",
  },
  { name: "publisher", label: "Publisher", type: "text", placeholder: "Enter Publisher" },
  { name: "publisherLogoUrl", label: "Publisher Logo URL", type: "text", placeholder: "Enter Logo URL" },
  { name: "portraitPosterUrl", label: "Portrait Poster URL", type: "text", placeholder: "Enter Poster URL" },
  { name: "favicons", label: "Favicon URL", type: "text", placeholder: "Enter Favicon URL" },
  { name: "analytics_ids", label: "Analytics IDs", type: "text", placeholder: "Enter Analytics IDs" },
  {
    name: "noOfPagesAllowed",
    label: "Number of Pages",
    type: "number",
    required: true,
    placeholder: "Enter Page Count",
    default: 50,
  },
  {
    name: "sortBy",
    label: "Pages Order",
    type: "select",
    options: [
      { value: "", label: "Select" },
      { value: "new", label: "New to Old" },
      { value: "old", label: "Old to New" },
    ],
  },
  {
    name: "storageId",
    label: "Storage",
    type: "select",
    placeholder: "Select Storage",
    dynamicOptions: true,
    required: true,
  },
  {
    name: "description",
    label: "Description",
    type: "textarea",
    placeholder: "Enter Description",
    fieldIncudedInCollapse: true,
  },
  {
    name: "thumbnailURL",
    label: "Thumbnail URL",
    type: "text",
    placeholder: "Enter Thumbnail URL",
    fieldIncudedInCollapse: true,
  },
  {
    name: "verticalThumbnailUrl",
    label: "Horizontal Thumbnail URL",
    type: "text",
    placeholder: "Enter Horizontal Thumbnail URL",
    fieldIncudedInCollapse: true,
  },
  { name: "twitterAccount", label: "Twitter", type: "text", placeholder: "@username", fieldIncudedInCollapse: true },
  { name: "siteName", label: "Site Name", type: "text", placeholder: "Enter Site Name", fieldIncudedInCollapse: true },
  {
    name: "isPreviousStoryTemplate",
    label: "Add Previous Story Template",
    type: "checkbox",
    fieldIncudedInCollapse: true,
  },
  {
    name: "previousStoriesData",
    type: "select",
    placeholder: "Select Story",
    dynamicOptions: true,
    fieldIncudedInCollapse: true,
    showOnlyWhenCheckboxSelected: true,
  },
];

export const organizationsSettingItems = [
  "basicinfo",
  "features",
  "users",
  "workSpaces",
  "operations",
  "manageDownloadLimit",
  "show",
  "folder",
  "datafeed",
  "upload_youtube_csv",
  "subclients",
  "package",
  "srt_encryption",
];

export const templateSettingItems = [
  "output_video_template",
  "stream_template",
  "video-transform-templates",
  "publishing-templates",
  "clip-naming-templates",
];

export const integrationsAndExternalConnectionSettingItems = [
  "storage",
  "client-webhook",
  "reserved-channel",
  "add_brightcove_user",
  "publish-storage",
  "ftp-credentials",
];

export const allowedSettingItems = ["video-transform-templates", "publishing-templates", "ftp-credentials"];

export const RICH_TEXT_EDITOR_FORMAT_OPTIONS = ["bold", "italic", "underline"];

export const RICH_TEXT_EDITOR_DEFAULT_INITIAL_VALUE = [
  { type: "paragraph", style: {}, tag: "div", children: [{ text: "" }] },
];

export const RICH_TEXT_EDITOR_VARIABLE_OPTIONS = {
  "tournament.tournamentName": "tournamentName",
  "team1.name": "team1",
  "team2.name": "team2",
  "clip.createdAt": "createdAt",
  previewLink: "previewLink",
};

export const CLIP_TYPES = {
  CLIP: "clip",
  HIGHLIGHT: "highlight",
  PROMO: "promo",
};

export const CLIP_RATING_TYPE = {
  AI: "AI",
  MANUAL: "manual",
  UNRATED: "unrated",
};

export const fieldStateOptions = [
  {
    value: "true",
    label: "Activated",
  },
  {
    value: "false",
    label: "Deactivated",
  },
];

export const fieldTypes = [
  { value: "TEXT", label: "Text" },
  { value: "SELECT", label: "Select" },
  { value: "INPUT_MASKING", label: "Input Masking" },
  { value: "BOOLEAN", label: "Boolean" },
];

export const CORE_FIELD_INPUT_TYPES = {
  TEXT: "text",
  SELECT: "select",
  INPUT_MASKING: "input_masking",
  BOOLEAN: "boolean",
};

export const CORE_FIELD_INPUT_TYPES_OPTIONS = [
  { value: CORE_FIELD_INPUT_TYPES.SELECT, label: "Select" },
  { value: CORE_FIELD_INPUT_TYPES.TEXT, label: "Text" },
  { value: CORE_FIELD_INPUT_TYPES.BOOLEAN, label: "Boolean" },
  { value: CORE_FIELD_INPUT_TYPES.INPUT_MASKING, label: "Input Masking" },
];

export const formTypeOptions = [
  { label: "Clip Tagging", value: "clip_tagging" },
  { label: "Stream", value: "stream" },
];

export const formTaggingOptions = [
  { label: "Events", value: "event" },
  { label: "Players", value: "player" },
  { label: "Teams", value: "teams" },
  { label: "Custom", value: "custom" },
];

export const FIELD_TYPES = {
  CORE: "core",
  METADATA: "metadata",
};

export const FIELD_PERMISSIONS = {
  ACTIVATE_ON_ORG: "activateOnOrg",
  SHOW_IN_TAG_LIST: "showInTagList",
  SHOW_ON_JSON: "showOnJSON",
  IS_MULTIPLE: "isMultiple",
};

export const BOOLEAN_OPTIONS = [
  { value: true, label: "True" },
  { value: false, label: "False" },
];

export const BOOLEAN_OPTIONS_STRING = [
  { value: "true", label: "True" },
  { value: "false", label: "False" },
];

export const TAG_TYPES = [
  { label: "Clip", value: "clip" },
  { label: "Highlight Clip", value: "highlight_clip" },
];

export const MATCH_SCHEDULE_VALIDATION_HOURS = 18;

export const TEAM_VARIABLE_PREFIX = "teamOf";
export const PLAYER_VARIABLE_TYPE = "player";

export const IS_COMBINED_TAGS_CSV_UPLOAD = true;

export const TAGS_CSV_UPLOAD_URL =
  "https://docs.google.com/spreadsheets/d/1b6_p4sUQJKdJ1l0lkVrL5XDvg73qsepoOH0LCQ_y8qk/copy";

//NB: These options are not currently supported, so we are not showing them in the UI.

export const EXTERNAL_SOURCE_LABELS = {
  wetransfer: "WeTransfer",
  "google-drive": "Google Drive",
  dropbox: "Dropbox",
};

export const EXTERNAL_SOURCE_TYPES_OPTIONS = [
  { value: "wetransfer", label: EXTERNAL_SOURCE_LABELS.wetransfer },
  // { value: "downloaded-url", label: "Downloaded URL" },
  // { value: "ftp", label: "FTP" },
  { value: "google-drive", label: EXTERNAL_SOURCE_LABELS["google-drive"] },
  // { value: "aws-drive", label: "AWS Drive" },
  { value: "dropbox", label: EXTERNAL_SOURCE_LABELS.dropbox },
  // { value: "youtube", label: "YouTube" },
  // { value: "onedrive", label: "OneDrive" },
  // { value: "mp4-url", label: "MP4 URL" },
  // { value: "myairbridge.com", label: "MyAirBridge.com" },
];

export const SINGLE_BITRATE = "SB";
export const MULTI_BITRATE = "MB";
export const ADMIN_DATAFEED_PERMISSIONS = {
  match_schedule: "Match Schedule",
  markers_live_video: "Markers Live Video",
  clip_cutting: "Clip Cutting",
  filters: "Filters",
  export_datafeed_json: "Export Datafeed JSON",
  add_to_clips_page: "Add to Clips Page",
  update_stats_perform_player_metadata: "Update Stats Perform Player Metadata",
};

export const ADMIN_DATAFEED_CATEGORIES = {
  football: "Football",
  volleyball: "Volleyball",
  ice_hockey: "Ice Hockey",
  handball: "Handball",
  tennis: "Tennis",
  "Moto Racing": "Moto Racing",
  curling: "Curling",
  basketball: "Basketball",
  "American Football": "American Football",
  korfball: "Korfball",
  golf: "Golf",
  bike_racing: "Bike Racing",
};

export const DEFAULT_DATAFEED_PERMISSIONS = {
  match_schedule: false,
  markers_live_video: false,
  clip_cutting: false,
  filters: false,
  export_datafeed_json: false,
  add_to_clips_page: false,
  update_stats_perform_player_metadata: false,
};

export const DEFAULT_DATAFEED_JOB_INTERVAL = {
  job_interval: "30 10 1,16 * *",
  is_active: false,
};

export const validateCron = (cron) => {
  const parts = cron?.trim()?.split(" ");
  if (parts?.length !== 5) {
    return "Cron must contain 5 fields";
  }
  const validators = [
    /^(\*|([0-5]?\d)(\/\d+)?|\*\/\d+|([0-5]?\d)-([0-5]?\d))(,(\*|[0-5]?\d))*$/, // minute
    /^(\*|([01]?\d|2[0-3])(\/\d+)?|\*\/\d+|([01]?\d|2[0-3])-([01]?\d|2[0-3]))(,(\*|([01]?\d|2[0-3])))*$/, // hour
    /^(\*|(0?[1-9]|[12]\d|3[01])(\/\d+)?|\*\/\d+|(0?[1-9]|[12]\d|3[01])-(0?[1-9]|[12]\d|3[01]))(,(0?[1-9]|[12]\d|3[01]))*$/, // day
    /^(\*|(0?[1-9]|1[0-2])(\/\d+)?|\*\/\d+|(0?[1-9]|1[0-2])-(0?[1-9]|1[0-2]))(,(0?[1-9]|1[0-2]))*$/, // month
    /^(\*|[0-6](\/\d+)?|\*\/\d+|[0-6]-[0-6])(,[0-6])*$/, // weekday
  ];
  for (let i = 0; i < 5; i++) {
    if (!validators[i].test(parts[i])) {
      return "Invalid cron format";
    }
  }
  return "";
};

export const showMaskedValue = (value) => {
  const visibleChars = 10;
  if (!value) return "-";
  const textCount = Math.max(0, String(value).length - visibleChars);

  return String(value).substring(0, visibleChars) + "*".repeat(textCount);
};

export const TV4_ORG = "org_e1d4ead6-29c5-4158-bc47-87266839adb5";

export const DATAFEED_PROVIDERS_OPTIONS = [
  { label: "KNKV", value: "knkv" },
  { label: "CBS", value: "cbs" },
  { label: "Stats Perform", value: "statsPerform" },
  { label: "Sportradar", value: "sportRadar" },
  { label: "TV2", value: "tv2" },
  { label: "Volley Station", value: "volleyStation" },
  { label: "Genius", value: "genius" },
  { label: "My Game Plan", value: "myGamePlan" },
  { label: "Nascar", value: "nascar" },
  { label: "Sport Media", value: "sportMedia" },
  { label: "Ringier", value: "ringier" },
  { label: "SMT", value: "smt" },
  { label: "Feld", value: "feld" },
];

export const ONE_GB = 1024 ** 3; // 1 GiB in bytes
